import { addDays } from "date-fns";
import { View } from "react-native";
import { Text } from "react-native-paper";
import { useTailwind } from "tailwind-rn";

import Eta from "@/src/components/eta";

const today = new Date();
today.setHours(17, 0, 0, 0);

export default function EtaExamples() {
  const tailwind = useTailwind();

  // mock today and a +/- a week of dates
  const dates = Array.from({ length: 15 }).map((_, i) => addDays(today, i - 7));

  return (
    <View style={tailwind("gap-4 m-4")}>
      {dates.map((date, index) => (
        <EtaWithLabel eta={date.toISOString()} key={index} />
      ))}
    </View>
  );
}

function EtaWithLabel({ eta }: { eta: string }) {
  const tailwind = useTailwind();
  return (
    <View style={tailwind("flex-row items-center gap-4")}>
      <Text>{eta}</Text>
      <Eta eta={eta} />
    </View>
  );
}
